<template>
  <div>
    <div class="text-right">
      <TermPicker outlined text v-model="term" :range="[-3, 0]" />
    </div>
    <v-card flat :loading="loading" class="mb-4">
      <div class="d-flex">
        <v-avatar class="ma-3" size="90">
          <PortraitImage v-if="overview" :value="overview.student" large />
        </v-avatar>
        <div class="grow">
          <v-card-title class="text-h5" v-if="overview"
            ><PersonName :value="overview.student"
          /></v-card-title>

          <v-card-subtitle v-if="overview"
            >{{ overview.student.schoolClass.code }}<br />
            Alter: {{ overview.student.age }} Jahre</v-card-subtitle
          >
        </div>
      </div>

      <v-chip-group column v-if="overview">
        <v-chip color="error" outlined
          >offen: {{ overview.pendingLessons }}</v-chip
        >

        <v-chip color="success" outlined
          >entschuldigt: {{ overview.excusedLessons }}</v-chip
        >

        <v-chip color="danger" outlined
          >unentschuldigt: {{ overview.unexcusedLessons }}</v-chip
        >

        <v-chip color="info" outlined
          >bezogene Halbtage: {{ overview.halfDays }}</v-chip
        >
      </v-chip-group>
    </v-card>

    <v-alert
      text
      :type="overview.warningLevel == 1 ? 'warning' : 'error'"
      :prominent="!$vuetify.breakpoint.xs"
      v-if="term && term.current && overview && overview.warningLevel > 0"
    >
      <v-row align="center">
        im aktuellen Semester gibt es bereits
        {{ overview.absentLessons }} Absenzen (inklusive pendenter
        Abwesenheiten)
      </v-row>
    </v-alert>
    <v-toolbar flat dense class="mb-4">
      <v-tabs centered>
        <v-tab exact :to="{ name: 'AbsencesStudentPending' }">Pendenzen</v-tab>
        <v-tab :to="{ name: 'AbsencesStudentCalendar' }">Kalender</v-tab>
        <v-tab :to="{ name: 'AbsencesStudentUnexcused' }"
          >Unentschuldigte</v-tab
        >
        <v-tab :to="{ name: 'AbsencesStudentArchive' }">Archiv</v-tab>
      </v-tabs>
    </v-toolbar>

    <router-view
      v-if="overview"
      @updated="fetchData()"
      :id="overview.student.id"
      :student="overview.student"
      :schoolClass="overview.student.schoolClass"
      :term="term"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";

import PersonName from "common/components/PersonName.vue";
import PortraitImage from "common/components/PortraitImage.vue";
import TermPicker from "common/components/TermPicker.vue";

export default defineComponent({
  components: {
    PersonName,
    PortraitImage,
    TermPicker,
  },
  props: {
    id: { type: Number, default: 0 },
  },
  data() {
    return {
      dateMenu: false,
      dialog: false,
      focus: "",
      loading: false,
      overview: null,
      term: { startDate: 0 },
    };
  },
  computed: {
    canEdit() {
      return this.overview && this.$_isClassTeacherOf(this.overview.student);
    },
  },
  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
    term() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      if (!this.id || !this.term) return;
      this.loading = true;
      this.overview = await this.apiList({
        resource: "absence/overview",
        query: `student=${this.id}&term=${this.term.id}`,
      });

      this.loading = false;
    },
  },
  created() {
    // this.fetchData();
  },
});
</script>
